import React from 'react';

export const FooterLink: React.FC<{ children: any; url: string; className: string }> = ({ children, url, className }) => {
    return (
        <>
            <a
                href={url}
                target='_blank'
                rel='noopener noreferrer'
                className={className}
            >
                {children}
            </a>
        </>
    );
};
